import React from 'react'
import { Plural, t } from '@lingui/macro'
import { ExpandableCardGrid } from 'front-end/src/components/common/expandable-card-grid/ExpandableCardGrid'
import { PageContentWrapper } from '../../../../components/common/page/Page'
import EventCard, { EventWithAttendeesCount } from '../event-card/EventCard'
import { useUpcomingEventsQuery } from './UpcomingEventsRow.codegen'
import dayjs from 'shared/dayjs'

export const UpcomingEventsRow = () => {
  const { data, loading } = useUpcomingEventsQuery({
    variables: {
      endingFrom: dayjs().startOf('minute').toISOString()
    }
  })

  if (loading || data?.events?.length === 0 || !data?.events) {
    return null
  }

  return (
    <PageContentWrapper className="UpcomingEvents">
      <ExpandableCardGrid
        title={t`Upcoming events`}
        cards={data.events.map((event) => (
          <EventCard event={event as EventWithAttendeesCount} key={event.id} />
        ))}
        renderShowMore={(remainingCards) => {
          return (
            <Plural
              value={remainingCards}
              one="Show # more event"
              other="Show # more events"
            />
          )
        }}
      />
    </PageContentWrapper>
  )
}
